interface ErrorBannerProps {
  message: string;
  onRetry?: () => void;
}

function ErrorBanner({ message, onRetry }: ErrorBannerProps) {
  if (!message) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed top-0 left-0 right-0 bg-destructive text-destructive-foreground py-2 px-4 text-center z-[9999]"
    >
      <span>Error: {message}</span>
      {onRetry && (
        <button
          onClick={onRetry}
          className="ml-2 bg-transparent border border-destructive-foreground text-destructive-foreground px-2 py-1 rounded hover:bg-destructive-foreground hover:text-destructive transition-colors"
          aria-label="Retry"
        >
          Retry
        </button>
      )}
    </div>
  );
}

export default ErrorBanner;
